import ClockoutController from '../../core/clockout.controller';

/**
 * @extends ClockoutController
 */
class ResetPasswordSuccessController extends ClockoutController {
    async initialize() {
        // Component initialized
    }

    async cleanup() {
        // Cleanup if needed
    }

    continueToSignIn() {
        this.navigateLogin();
    }

    navigateToSignIn() {
        window.location.href = '/';
    }
}

export default ResetPasswordSuccessController;

